import i18n from "i18n";

// Where the translated label of each option list lives. Callers must load the namespace
// through their own `useTranslation([...])` so they re-render once it is available.
const GROUP_KEYS = {
  allocation: "common:enums.allocation",
  marketRate: "common:enums.marketRate",
  communityOrAggregator: "common:enums.communityOrAggregator",
  meterType: "common:enums.meterType",
  meterInstallation: "common:enums.meterInstallation",
  erseTariffType: "common:enums.erseTariffType",
  period: "common:enums.period",
  userRole: "common:enums.userRole",
  voltageLevel: "contracts:options.voltage_levels",
  ciclesType: "contracts:options.cicles",
  contractType: "contracts:options.types",
  resourceType: "resources:new_resource.selects.types",
};

/** Translated label for one option value, falling back to `fallback` (or the value itself). */
export const enumLabel = (group, value, fallback) =>
  i18n.t(`${GROUP_KEYS[group]}.${value}`, { defaultValue: fallback ?? String(value) });

/** Same options with every `label` translated for the current language. */
export const translateOptions = (options, group) =>
  options.map((option) => ({ ...option, label: enumLabel(group, option.value, option.label) }));
